import * as CookieConsent from 'vanilla-cookieconsent/dist/core/cookieconsent-core.esm.js';
import MapiToggleCookieModal from "./MapiToggleCookieModal";


const MapiCookies = () => {
    const cc = CookieConsent;
    const btnEssential = document.getElementById('MapiCookieBtnEssential');
    const btnAll = document.getElementById('MapiCookieBtnAcceptAll');
    const btnAcceptSelected = document.getElementById('MapiCookieBtnAcceptSelected');
    const analyticsCookiesCheck = document.getElementById('MapiAnalyticsCookies');
    const adsCookiesCheck = document.getElementById('MapiAddsCookies');
    const additionalCookiesCheck = document.getElementById('MapiAdditionalCookies');
    const cookieData = window.mapi_cookie_data;
    for (let category in cookieData) {
        cookieData[category].autoClear.cookies.forEach(cookie => {
            // Check if the string starts and ends with "/" to identify regex patterns
            if (cookie.name.startsWith('/') && cookie.name.endsWith('/')) {
                // Remove the starting and ending slashes
                let regexPattern = cookie.name.slice(1, -1);
                cookie.name = new RegExp(regexPattern);
            }
        });
    }


    gtag('consent', 'default', {
        'ad_storage': 'denied',
        'analytics_storage': 'denied',
        'ad_user_data': 'denied',
        'ad_personalization': 'denied',
    });


    function updateGtagConsent(cookie) {
        console.log('Updating gtag consent with:', cookie.categories);

        gtag('consent', 'update', {
            'analytics_storage': cookie.categories.includes('analytics') ? 'granted' : 'denied',
            'ad_storage': cookie.categories.includes('ads') ? 'granted' : 'denied',
            'ad_user_data': cookie.categories.includes('ads') ? 'granted' : 'denied',
            'ad_personalization': cookie.categories.includes('ads') ? 'granted' : 'denied'
        });
    }


    const categories = {
        necessary: {
            readOnly: true,
            enabled: true,
        },
        ...cookieData
    };

    cc.run({
        categories,

        onFirstConsent: ({cookie}) => {
            updateGtagConsent(cookie)
        },

        onConsent: ({cookie}) => {
            updateGtagConsent(cookie)
        },

        onChange: ({cookie, changedCategories}) => {
            updateGtagConsent(cookie)
        },
    }).then(() => {
        /**
         * Show dialog if
         * consent is not valid
         */
        if (!cc.validConsent()) {
            MapiToggleCookieModal('show');
        }

    });

    btnEssential.addEventListener('click', () => {
        cc.acceptCategory([]);
        MapiToggleCookieModal('hide');
    });

    btnAll.addEventListener('click', () => {
        cc.acceptCategory('all');
        MapiToggleCookieModal('hide');
    });


    btnAcceptSelected.addEventListener('click', () => {
        const accepted = [];

        if (analyticsCookiesCheck !== null && analyticsCookiesCheck.checked) {
            accepted.push('analytics')
        }

        if (adsCookiesCheck !== null && adsCookiesCheck.checked) {
            accepted.push('ads')
        }

        if (additionalCookiesCheck !== null && additionalCookiesCheck.checked) {
            accepted.push('additional')
        }

        cc.acceptCategory(accepted);

        MapiToggleCookieModal('hide');


    });
}


export default MapiCookies;